import Swiper from "swiper/bundle";
import kissImage from "../../../assets/images/icon-kiss.png";

export default () => {
    const swiper = new Swiper('.swiper', {
        loop: true,

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}">
				<span class="inline-block bullet-active !w-[2.1rem]">
					<img
						src="${kissImage}"
						class="h-8"
						alt=""
					/>
				</span>
				<span class="bullet-inside"></span>
			</span>
		`
            },
        },
    })
}
